import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from '@yoweb/next-i18next';
import { FlyoutBack } from '@poplar/components/Flyout/FlyoutBack';
import { FlyoutClose } from '@poplar/components/Flyout/FlyoutClose';
import { Text, Label } from '@yoweb/ui/components/typography';
import { FlyoutStepHeader, FlyoutTitle, HeaderContainer } from '@poplar/components/Flyout/FlyoutTodo/common';
import { AccessType, TodoEditType } from '@poplar/types/enums';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(props) {
  var onSlideClose = props.onSlideClose,
      onSlideBack = props.onSlideBack,
      allowNavigation = props.allowNavigation,
      initialTask = props.initialTask,
      _props$isHeaderCompac = props.isHeaderCompact,
      isHeaderCompact = _props$isHeaderCompac === void 0 ? false : _props$isHeaderCompac,
      headerElementRef = props.headerElementRef,
      questionIndex = props.questionIndex,
      setQuestionIndex = props.setQuestionIndex,
      setPathOfBranchingQuestions = props.setPathOfBranchingQuestions,
      pathOfBranchingQuestions = props.pathOfBranchingQuestions,
      title = props.title,
      todoEditType = props.todoEditType,
      isSubscriptionFlow = props.isSubscriptionFlow;
  var isEditing = !!initialTask;
  var showSmallHeader = isEditing || isSubscriptionFlow;
  var isForRecurringQuestionEdit = todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION;

  var _useExternalConfig = useExternalConfig(),
      globalFeatures = _useExternalConfig.globalFeatures;

  var _useEntitlement = useEntitlement(),
      accessType = _useEntitlement.accessType; // Show subscription flow if the user has not subscribed OR
  // when onboarding v2.2 ff is enabled and the user does not have full access (but has not canceled or paused)


  var showSubscriptionFlow = isSubscriptionFlow || globalFeatures.enableOnboarding2_2 && accessType !== AccessType.FULL && accessType !== AccessType.CANCELED && accessType !== AccessType.PAUSED;

  var onBack = function onBack() {
    if (!allowNavigation) {
      return;
    }

    if (pathOfBranchingQuestions.length > 0) {
      // pathOfBranchingQuestions is 1 indexed
      setQuestionIndex(pathOfBranchingQuestions[pathOfBranchingQuestions.length - 1] - 1);
      setPathOfBranchingQuestions(pathOfBranchingQuestions.slice(0, -1));
    } else {
      if (showSubscriptionFlow) {
        onSlideClose(true);
      }

      onSlideBack === null || onSlideBack === void 0 ? void 0 : onSlideBack();
    }
  };

  var onClose = function onClose() {
    if (!allowNavigation) {
      return;
    }

    onSlideClose();
  };

  return /*#__PURE__*/_jsxs(FlyoutStepHeader, {
    ref: headerElementRef,
    $isCompact: isHeaderCompact,
    backgroundColor: isEditing && !showSubscriptionFlow ? 'base000' : 'gingko',
    $pt: showSmallHeader ? 'normal3' : 'medium3',
    children: [/*#__PURE__*/_jsx(HeaderContainer, {
      children: /*#__PURE__*/_jsx(HeaderContent, _objectSpread(_objectSpread({}, props), {}, {
        isSubscriptionFlow: showSubscriptionFlow
      }))
    }), (!isEditing || showSubscriptionFlow) && /*#__PURE__*/_jsx(AnimatePresence, {
      children: !isHeaderCompact && /*#__PURE__*/_jsx(FlyoutTitle, {
        fontSize: showSubscriptionFlow ? 'titleSm' : 'titleMd',
        "data-testid": "title-intake",
        children: title
      })
    }), (questionIndex > 0 || onSlideBack) && !isForRecurringQuestionEdit && /*#__PURE__*/_jsx(FlyoutBack, {
      size: showSmallHeader ? 'sm' : 'md',
      onClick: onBack,
      "data-testid": "back-todo-intake-button"
    }), !showSubscriptionFlow && /*#__PURE__*/_jsx(FlyoutClose, {
      size: showSmallHeader ? 'sm' : 'md',
      onClose: onClose,
      "data-testid": "close-todo-intake-button"
    })]
  });
};

var HeaderContent = function HeaderContent(_ref) {
  var isLoading = _ref.isLoading,
      questionIndex = _ref.questionIndex,
      questionsList = _ref.questionsList,
      todoEditType = _ref.todoEditType,
      isSubscriptionFlow = _ref.isSubscriptionFlow;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  if (todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION) {
    return /*#__PURE__*/_jsx(Label, {
      size: "sm",
      weight: "bold",
      "data-testid": "intake-edit-recurring",
      children: t('recurring.edit-recurring')
    });
  }

  if (!isLoading) {
    var _questionsList$length;

    return /*#__PURE__*/_jsx(Text, {
      size: "sm",
      weight: "bold",
      "data-testid": "intake-step-count",
      children: isSubscriptionFlow ? t('todo-promo-summary.step', {
        ns: 'common'
      }) : t('todo-intake.page-stepper-info', {
        ns: 'common',
        current: questionIndex + 1,
        // +1 for the Summary step
        total: ((_questionsList$length = questionsList === null || questionsList === void 0 ? void 0 : questionsList.length) !== null && _questionsList$length !== void 0 ? _questionsList$length : 0) + 1
      })
    });
  }
};